<!-- 我的开发者主页 -->
<template>
    <div id="MyIndexWrap">
        <div class="PersonContentWrap">
            <div class="ButtonWrap flexa">
                <div class="Time"><p>平台有效期至  {{ PersonData.Time }}</p></div>
            <!--    <div class="flexa Auto"><span>自动续费</span> <el-switch
                        v-model="value"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                </el-switch></div>-->
                <div class="Button flexa">
                <div class="flex Continue">续费</div>
                <div class="flex Up">升级</div>
                </div>
            </div>
            <div class="Platform flex">
                <i  @click="OpenSenchaBox('model')"><img src="../assets/pt1.png"></i>
                <i  @click="OpenSenchaBox('manager')"><img src="../assets/pt2.png"></i>
                <i  @click="OpenSenchaBox('xietong')"><img src="../assets/pt3.png"></i>
            </div>
            <div @click="ClosePersonBox" class="Close"><img src="../assets/pclose.png"></div>
            <div class="PersonHead flexa">
                <i class="HeadPic">
                    <img v-if="PersonData.Head" :src="PersonData.Head">
                    <img v-else src="../assets/defaulthead.png">
                </i>
                <div class="HeadText">
                <i class="edit" @click="OpenEdit"><img src="../assets/editindex.png"></i>
                    <div class="Name"><p><strong>HELLO<span style="color: red">!</span></strong></p><p>{{ PersonData.Name }}</p></div>
                </div>
            </div>
            <div class="Info">
           <!--     <div class="flexa"><img src="../assets/p_1icon.png"><p>联系地址</p></div>-->
                <div class="flexa Infoitem" v-if="PersonData.Phone!==''"><img src="../assets/p_2icon.png"><p>{{ PersonData.Phone }}</p></div>
                <div class="flexa Infoitem" v-if="PersonData.Email!==''"><img src="../assets/p_3icon.png"><p>{{ PersonData.Email }}</p></div>
                <div class="flexa Infoitem" v-if="PersonData.Type!==''"><img src="../assets/p_4icon.png"><p>{{ PersonData.Type }}</p></div>
                <div class="Itemcard clearfix" v-if="PersonData.Items.length>0">
                    <div class="flex" v-for="(item,index) in PersonData.Items" :key="index">{{ item }}</div>
                </div>
            </div>
            <div class="LineCut flexbetween">
                <div class="NewsTitle flexa"><p>开发者 <span>简介</span></p></div>
            </div>
            <div class="Translate">
                <p v-if="PersonData.Info!==''">{{ PersonData.Info }}</p>
                <p v-else>暂无简介</p>
            </div>
        </div>
    </div>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';
  export default {
    name: 'myindex',
    components: {},
    props: {
      PersonData: Object
    },
    data() {
      return {
        value: true
      };
    },
    methods: {
      OpenSenchaBox(type) {
        // debugger;
        if (type === 'model') {
          this.$store.dispatch('setplatformname', 'PaaS平台');
        } else if (type === 'authentication' || type === 'normal' || type === 'manager' || type === 'test') {
          this.$store.dispatch('setplatformname', 'SaaS平台');
        }
        if (this.LoginUserInfo.userId) {
          if (type === 'authentication' || type === 'normal') { // 认证 运营
            this.$store.dispatch('togglesenchabox', true);
            window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
          } else if (type === 'build') { // 建模
            this.$store.dispatch('togglesenchabox', true);
            window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
          } else if (type === 'model') { // 平台 配置
            this.$store.dispatch('togglesenchabox', true);
            window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
          } else if (type === 'gptplatform') { // 平台 配置
            this.$store.dispatch('togglesenchabox', true);
            window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
          } else if (type === 'manager') { // 平台 配置
            axios({
              method: 'GET',
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
              url: this.$loginUrl + 'api/login/getnewtoken', // ?userid=50018,b86a7eb3-beff-4f49-9fb7-3abedc928661.杨福华0&eom=00326',
              params: {
                userid: this.LoginUserInfo.userId, // + '.' + this.LoginUserInfo.username,
                identity: type,
                eomid: this.currentSystem.code,
                getportal: '1',
                changeeom: '1'
              }
            }).then((res) => {
              if (res.data.code === 0) {
                this.$store.dispatch('togglesenchabox', true);
                window.GEVAR.MainController.addInitPage({ user: [res.data.data.user], platform: type, data: res.data.data, code: this.currentSystem.code, name: this.currentSystem.name });
              } else if (res.data.code === -1) {
                let errormsg = res.data.msg || '对应操作无效';
                this.$alert(errormsg, '提示', {
                  confirmButtonText: '确定'
                });
              }
            });
          } else if (type === 'xietong') { // 协同平台
            this.$store.dispatch('togglesenchabox', true);
            window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
          }
        }
      },
      OpenEdit() {
        this.$emit('OpenEdit');
      },
      ClosePersonBox() {
        this.$emit('OpenPersonBox');
      }
    },
    computed: {
      ...mapGetters(['LoginUserInfo', 'currentSystem'])
    }
  };
</script>
<style scoped lang="scss">
    @import '../../public/Value';
    #MyIndexWrap{
        .Platform{
            width: 96%;
            margin: 0 auto 0.15rem;
            i{
                width: 31%;
                cursor: pointer;
                img{
                    width: 100%;
                }
            }
            i:nth-child(2){
                margin: 0 2%;
            }
        }
        .ButtonWrap{
            width: 93%;
            height: 0.11rem;
            margin: 0 auto 0.1rem;
            position: relative;
            .Time{
                font-size: $TextSize;
                color: #666666;
            }
            .Button{
                position: absolute;
                right: 0;
            }
           .Up,.Continue{
                width: 0.36rem;
                height: 0.11rem;
                border-radius: 0.12rem;
                font-size: $AdditionTextSize;
                color: #fff;
                margin-left: 0.1rem;
                cursor: pointer;
            }
            .Continue{
                background-color: #cc9900;
            }
            .Up{
                background-color: #0066cc;
            }
        }
        .Close{
            width: 0.12rem;
            height: 0.12rem;
            position: absolute;
            right: 0.06rem;
            top: 0.06rem;
            cursor: pointer;
            img{
                width: 100%;
                height: 100%;
            }
        }
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #f5f5f5;
        border-radius: 0.06rem 0.06rem 0 0;
        padding-top: 1px;
        background-image: url("../assets/logobg.png");
        background-repeat: no-repeat;
        background-size: 2.3rem;
        background-position: right top;
        .PersonContentWrap{
            .Translate{
                width: 93%;
                padding: 0.1rem;
                margin: 0.1rem auto 0;
                box-sizing: border-box !important;
                background-color: #fff;
                border-radius: 0.1rem;
                box-shadow: 0 0 10px #e2e2e2;
                p{
                    font-size: $TextSize;
                    color: #000;
                    line-height: 0.078rem;
                }
            }
            .LineCut{
                width: 93%;
                margin: 0.05rem auto 0.05rem;
                border-bottom: 2px solid #000;
                .Return{
                    cursor: pointer;
                    p{
                        font-size: $AdditionTextSize;
                        color: #fff;
                    }
                    img{
                        width: 0.05rem;
                        margin-left: 0.02rem;
                    }
                }
                .NewsTitle{
                    p{
                        font-size: $TitleSize;
                        color: #000;
                        padding-bottom: 0.045rem;
                        span{
                            opacity: 0.6;
                            font-weight: normal;
                        }
                    }
                }
            }
            .Info{
                margin-left: 0.12rem;
                margin-top: 0.07rem;
               .Infoitem{
                    height: 0.18rem;
                    img{
                        width: 0.075rem;
                    }
                    p{
                        font-size:$TextSize;
                        color: #000;
                        margin-left: 0.08rem;
                    }
                }
                .Itemcard{
                    width: 96%;
                    margin-top: 0.05rem;
                    div{
                        height: 0.1rem;
                        padding: 0 0.08rem;
                        box-sizing: border-box;
                        background-color: #999999;
                        color: #fff;
                        border-radius: 0.1rem;
                        font-size: $AdditionTextSize;
                        margin-right: 0.05rem;
                        float: left;
                        margin-bottom: 0.05rem;
                    }
                    .AddItem{
                        background-color: #00a7e6;
                        ::v-deep .el-button--text{
                            color: #fff;
                            cursor: pointer;
                        }
                    }
                }
            }
            .PersonHead{
                height: 0.4rem;
                margin-left: 0.1rem;
                position: relative;
                .HeadPic img{
                    width:0.4rem;
                    height: 0.4rem;
                    object-fit: cover;
                    border-radius: 0.08rem;
                }
                .HeadText{
                    height: 0.4rem;
                    margin-left: 0.06rem;
                    .edit{
                        width: 0.09rem;
                        margin-bottom: 0.12rem;
                        margin-top: 0.02rem;
                        cursor: pointer;
                        img{
                            width: 100%;
                        }
                    }
                    .Name{
                        p:last-child{
                            font-size: $SmallTitleSize;
                            font-weight: bold;
                            color: #666666;
                        }
                        p:first-child{
                            font-size: $SmallTitleSize;
                            margin-bottom: 0.02rem;
                        }
                    }
                }
            }
            width: 96%;
            margin: 0 auto;
            height: calc(100% - 0.25rem);
            margin-top: 0.25rem;
            overflow-y: scroll;
            overflow-x: hidden;
            padding-bottom: 0.2rem;
            box-sizing: border-box !important;
            &::-webkit-scrollbar {
                width: 2px;
                height: 2px;
            }
            &::-webkit-scrollbar-track {
                width: 2px;
                background: #d2d2d2;

            }

            &::-webkit-scrollbar-thumb {
                width: 2px;
                background: #444444;
            }
        }
    }
</style>
